import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Data } from '../../components';

const CaseStudyQuote = props => {
  const { text, name, title, logo, className } = props;

  const classes = cx('caseStudy__quote', className);

  return (
    <div className={classes}>
      <blockquote className="quote quote--large u-textHeading u-textFluid--h3-h4 u-mb--large">
        <Data markdown>{text}</Data>
      </blockquote>
      <cite className="caseStudy__quote-cite">
        <h4 className="caseStudy__quote-name u-mb--remove">
          <Data>{name}</Data>
        </h4>
        <h5 className="caseStudy__quote-cite-sub">
          <Data>{title}</Data> at&nbsp;&nbsp;
          <img src={logo} className="caseStudy__quote-logo" alt={title} />
        </h5>
      </cite>
    </div>
  );
};

CaseStudyQuote.propTypes = {
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default CaseStudyQuote;
